import { Button } from 'antd';
import React, { useEffect } from 'react';
import { useTimer } from 'react-timer-hook';

const CountdownButton = (props) => {
    const { handleResend, resetTfaTimer, handleReset } = props;

    const time = new Date();
    time.setSeconds(time.getSeconds() + 60); // 60 seconds

    const { seconds, start, pause, restart } = useTimer({
        expiryTimestamp: time,
        onExpire: () => {
            pause();
            handleReset()
        }
    })

    useEffect(() => {
        start();
    }, [])
    
    useEffect(() => {
        if(resetTfaTimer) {
            setTimeout(() => {
                restart(time);
            }, 1000)
        }
    }, [resetTfaTimer])

    if(seconds === 0) {
        return (
            <Button
                onClick={() => handleResend()}
            >
                Resend
            </Button> 
        )
    }
 
    return (
        <span style={{ color: '#8c8c8c' }}>Resend in {seconds}</span>
    );
}

export default CountdownButton;